import * as React from 'react';
import HTMLEditor from './HTMLEditor';
import Loader from '../../../Loader';

interface MedicalHistoryEditorProps {
  initialValue?: string | null;
  loading: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

const MedicalHistoryEditor: React.FC<MedicalHistoryEditorProps> = (props) => {
    const { initialValue, loading, onChange, onBlur } = props;
    
    // Check if content contains HTML tables and use HTMLEditor for better support
    const hasHTMLContent = initialValue && (
        initialValue.includes('<table') ||
        initialValue.includes('<div') ||
        initialValue.includes('<span') ||
        initialValue.includes('style=')
    );

    if (hasHTMLContent) {
        return React.createElement(HTMLEditor, {
            initialValue,
            loading,
            onChange,
            onBlur
        });
    }

    // For simple content, you could still use ReactQuill if preferred
    // But for now, let's use HTMLEditor for all content
    return React.createElement(HTMLEditor, {
        initialValue,
        loading,
        onChange,
        onBlur
    });
};

export default MedicalHistoryEditor; 